import React from 'react';
import BaseComponent from '../../common/BaseComponent/BaseComponent';
import styles from './ComponentTestimonials.scss';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import TestimonialBlockV2, {
	TestimonialBlockV2Body,
	TestimonialBlockV2Author
} from "../../common/primitives/TestimonialBlockV2";
import {__t} from '../../common/lang/text-resource';

class ComponentTestimonials extends BaseComponent {
	constructor() {
		super(...arguments, 'ComponentTestimonials');
	}


	getTestimonials = () => {
		const testimonials = this.context.get(this.componentName).componentData;

		return testimonials.map((testimonial, k) => {
			return (
			  <TestimonialBlockV2Body key={testimonial.id}>
				  <p dangerouslySetInnerHTML={{__html: testimonial.fullText}}/>
				  <TestimonialBlockV2Author>
					  <p dangerouslySetInnerHTML={{__html: testimonial.quoteFrom}}/>
				  </TestimonialBlockV2Author>
			  </TestimonialBlockV2Body>
			)
		})
	}

	render() {
		const testimonials = this.context.get(this.componentName).componentData;

		if (!testimonials) {
			return null;
		}

		const subHeader = this.props.subHeader;
		let heading = <p className={styles.subHeading}>
			{__t('винаги-е-приятно-да-чуеш-че-клиентите-ти-са-доволfda574')}
			<br/>
			<a
			  href={__t('https-blog-superhosting-bg-category-superhosting-8dcb2e')}
			  target={"_blank"}
			  rel="noopener noreferrer">
				{__t('Имаме много поводи за гордост')}
			</a>{__t(', а медиите често отразяват нашите активности.')}
		</p>;

		if (subHeader !== '') {
			heading = <p className={styles.subHeading}>{subHeader}</p>
		}

		return (
		  <section className={styles.containerOuter} data-test="homepage-testimonials">
			  <h2>{__t('Другите за нас')}</h2>
			  {heading}

			  <div className={styles.testimonialsContainer}>
				  <TestimonialBlockV2>
					  {this.getTestimonials()}
				  </TestimonialBlockV2>
			  </div>
		  </section>
		)
	}
}

ComponentTestimonials.defaultProps = {
	subHeader: ''
};

// React Context binding
ComponentTestimonials.contextType = ContextDataStore;

export default ComponentTestimonials;
